<script setup lang="ts">
import InformationBaseCard from '@/components/Cards/InformationBaseCard.vue'
import type { EventModel } from '@/types/models/EventModel'
import StackLayout from '../../../../components/Layouts/StackLayout.vue'
import type { DeviceModel } from '../../../../types/models/DeviceModel'
import EventAddGuntimeAction from './EventAddGuntimeAction.vue'
import EventSetFilterAction from './EventSetFilterAction.vue'

type Props = {
    data: EventModel
    devices?: Partial<DeviceModel>[]
}
defineProps<Props>()

type Emits = {
    (e: 'refresh'): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCard :label="$t('event.title.actionsTitle')" class="fit-width fit-height">
        <StackLayout :gap="8" isResponsive>
            <EventSetFilterAction :data="data" />
            <EventAddGuntimeAction :data="data" @refresh="$emit('refresh')" />
        </StackLayout>
    </InformationBaseCard>
</template>
